module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/5-47d31df585d40bf53e984cee38579159.jpg";